import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OrganisationService } from '@principle-theorem/ng-principle-shared';
import { AbstractResolver } from '@principle-theorem/ng-shared';
import { Brand } from '@principle-theorem/principle-core';
import { IMarketingCampaign } from '@principle-theorem/principle-core/interfaces';
import {
  filterUndefined,
  getDoc$,
  type WithRef,
} from '@principle-theorem/shared';
import { type Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class MarketingCampaignResolverService extends AbstractResolver<
  WithRef<IMarketingCampaign>
> {
  constructor(
    router: Router,
    private _organisation: OrganisationService
  ) {
    super(router);
  }

  getItemById(uid: string): Observable<WithRef<IMarketingCampaign>> {
    return this._organisation.brand$.pipe(
      filterUndefined(),
      switchMap((brand) => getDoc$(Brand.marketingCampaignCol(brand), uid))
    );
  }
}
